/**
 * LandingNav Component
 * Navigation bar for landing page
 */

import { Menu, X } from 'lucide-react';
import type { ReactElement } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export function LandingNav(): ReactElement {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-theme-surface border-b border-theme-border backdrop-blur-sm bg-opacity-95">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-theme-primary to-theme-primary-hover rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">P</span>
            </div>
            <span className="text-xl font-bold text-theme-text">Parlay Picker</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <a
              href="#features"
              className="text-sm text-theme-text-secondary hover:text-theme-text transition"
            >
              Features
            </a>
            <a
              href="#pricing"
              className="text-sm text-theme-text-secondary hover:text-theme-text transition"
            >
              Pricing
            </a>
            <Link
              to="/login"
              className="text-sm text-theme-text-secondary hover:text-theme-text transition"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="px-4 py-2 bg-theme-primary-fill hover:bg-theme-primary-fill-hover text-theme-on-primary-fill text-sm font-medium rounded-lg transition"
            >
              Sign Up Free
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-theme-text-secondary hover:text-theme-text"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-theme-border py-4 space-y-2">
            {/* biome-ignore lint/a11y/useValidAnchor: Hash links for section navigation */}
            <a
              href="#features"
              className="block px-4 py-2 text-sm text-theme-text-secondary hover:text-theme-text hover:bg-theme-surface-hover rounded transition"
              onClick={() => setMobileMenuOpen(false)}
            >
              Features
            </a>
            {/* biome-ignore lint/a11y/useValidAnchor: Hash links for section navigation */}
            <a
              href="#pricing"
              className="block px-4 py-2 text-sm text-theme-text-secondary hover:text-theme-text hover:bg-theme-surface-hover rounded transition"
              onClick={() => setMobileMenuOpen(false)}
            >
              Pricing
            </a>
            <Link
              to="/login"
              className="block px-4 py-2 text-sm text-theme-text-secondary hover:text-theme-text hover:bg-theme-surface-hover rounded transition"
              onClick={() => setMobileMenuOpen(false)}
            >
              Login
            </Link>
            <Link
              to="/register"
              className="block mx-4 px-4 py-2 bg-theme-primary-fill hover:bg-theme-primary-fill-hover text-theme-on-primary-fill text-sm font-medium rounded-lg text-center transition"
              onClick={() => setMobileMenuOpen(false)}
            >
              Sign Up Free
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
